module.exports = __webpack_public_path__ + "img/lcc1.99dd586c.png";